import { Injectable } from '@angular/core';
import { PublicationTable, PublicationTableSchema } from 'src/app/infra/database/dexie/instance/action/schema/publication';
import { PublicationFileTable } from 'src/app/infra/database/dexie/instance/action/schema/publicationFile';
import { actionDatabase } from 'src/app/infra/database/dexie/instance/action/service';
import { DexieRepository } from 'src/app/infra/repository/dexie/dexie-repository.service';

@Injectable({
  providedIn: 'root'
})
export class PublicationLocalRepositoryService extends DexieRepository<PublicationTable, PublicationTable> {

  constructor() {
    super(actionDatabase.publication, PublicationTableSchema, actionDatabase)
  }
}
